import React from 'react';

import { FaGithub, FaLinkedin, FaFacebook, FaInstagram } from 'react-icons/all';

import './styles.css';

export default function Contact() {
    return(
        <div className="contact-container" id="contact">
            <h1 className="contact-title">
                Contato
            </h1>
            <h2 className="contact-description">
                Fique à vontade para entrar em contato
            </h2>
            <div className="contact-content">
                <div className="contact-infos-list">
                    <div className="contact-info">
                        <h2 className="contact-info-title">
                            Telefones
                        </h2>
                        <p className="contact-info-text">
                            Fixo: (62)3278-5450 <br />
                            Celular: (62)9 8167-0584
                        </p>
                    </div>
                    <div className="contact-info">
                        <h2 className="contact-info-title">
                            E-mails
                        </h2>
                        <p className="contact-info-text">
                            andreastrol29@gmail.com <br />
                            alaodev@gmail.com
                        </p>
                    </div>
                    <div className="contact-info">
                        <h2 className="contact-info-title">
                            Endereço
                        </h2>
                        <p className="contact-info-text">
                            Vila Maria, Aparecidade de Goiânia - GO
                        </p>
                    </div>
                    <div className="contact-info">
                        <h2 className="contact-info-title">
                            Redes sociais
                        </h2>
                        <p className="contact-info-text">
                            <div className="social-icons">
                                <a 
                                    href="https://github.com/alaodev" 
                                    target="_blank"
                                >
                                    <FaGithub />
                                </a>
                                <a 
                                    href="https://www.linkedin.com/in/alaodev" 
                                    target="_blank"
                                >
                                    <FaLinkedin />
                                </a>
                                <a 
                                    href="https://web.facebook.com/profile.php?id=100026429555285" 
                                    target="_blank"
                                >
                                    <FaFacebook />
                                </a>
                                <a 
                                    href="https://www.instagram.com/default_follower/" 
                                    target="_blank"
                                >
                                    <FaInstagram />
                                </a>
                            </div>  
                        </p>
                    </div>
                </div>
                <div className="contact-form">
                    <form>
                        <input 
                            type="text"
                            placeholder="Nome"
                        />
                        <input 
                            type="email"
                            placeholder="E-mail"
                        />
                        <textarea 
                            placeholder="Deixe um recado..."
                        />
                        <button
                            type="submit"
                        >
                            Enviar
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}